import { lazy } from 'react';

export const PreoffersAsync = lazy(() => import('./preoffers.component'));
